import axios from 'axios';
import routes from 'app/routes';

export default {
  load: (dispatch, enterpriseId) => {
    axios.get(`${routes.api.managers.payment_methods.index}?enterpriseId=${enterpriseId}`).then((resp) => {
      dispatch({ type: 'LOAD', paymentMethods: resp.data.data });
    });
  },
  prepareBillingInformation: (enterpriseId, callback) => {
    axios
      .get(`${routes.api.managers.payment_methods.new}?enterpriseId=${enterpriseId}`)
      .then((resp) => {
        callback(resp.data.data);
      });
  },

  savePaymentMethod: (dispatch, enterpriseId, paymentMethodId, values, successCallback, errorCallback) => {
    const createPaymentMethod = () => axios
      .post(`${routes.api.managers.payment_methods.create}?enterpriseId=${enterpriseId}`, {
        payment_information: values,
      });

    const updatePaymentMethod = () => axios
      .put(`${routes.api.managers.payment_methods.update(paymentMethodId)}?enterpriseId=${enterpriseId}`, {
        payment_information: values,
      });

    const request = paymentMethodId === ''
      ? createPaymentMethod()
      : updatePaymentMethod();

    request.then((resp) => {
      dispatch({ type: 'ADD_OR_UPDATE_PAYMENT_METHOD', paymentMethod: resp.data.data });
      successCallback();
    })
      .catch((error, _data) => {
        errorCallback(error.response.data.errors);
      });
  },
  deletePaymentMethod: (dispatch, enterpriseId, paymentMethodId) => {
    axios
      .delete(`${routes.api.managers.payment_methods.delete(paymentMethodId)}?enterpriseId=${enterpriseId}`)
      .then((_resp) => {
        dispatch({ type: 'DELETE_PAYMENT_METHOD', paymentMethodId });
      });
  },
};
